/*eslint-disable*/
import createReducer from '../createReducer';
import {
  FETCH_CONFIGURATION_DATA,
  FETCH_CONFIGURATION_DATA_SUCCESS,
  FETCH_CONFIGURATION_DATA_ERROR,
  UPDATE_TASK_LOCALLY,
  UPDATE_TASK,
  UPDATE_TASK_SUCCESS,
  UPDATE_CONFIGURATION,
  UPDATE_CONFIGURATION_SUCCESS,
  UPDATE_ERRORS,
  DELETE_CAPABILITIES,
  DELETE_CAPABILITIES_SUCCESS,
  FETCH_CAPABILITIES,
  FETCH_CAPABILITIES_SUCCESS,
  UPDATE_CAPABILITIES,
  UPDATE_CAPABILITIES_SUCCESS,
  UPDATE_CAPABILITIES_ERROR,
  FETCH_PARTS,
  FETCH_PARTS_SUCCESS,
  FETCH_PARTS_ERROR,
  UPDATE_PARTS,
  UPDATE_PARTS_SUCCESS,
  UPDATE_PARTS_ERROR,
  SAVE_DISCOUNT,
  SAVE_DISCOUNT_SUCCESS,
} from '../actions/configuration';

export const initialState = {
  taskData: null,
  configurationData: null,
  readOnly: true,
  configurationDataLoading: false,
  saving: false,
  errors: null,
  capabilities: null,
  partsData: null,
  displayGetPartsError: false,
  refreshPartsLoading: false,
};

export default createReducer(initialState, {
  // [FETCH_CONFIGURATION_DATA]: draft => {
  //   draft.configurationDataLoading = true;
  // },
  //
  // [FETCH_CONFIGURATION_DATA_SUCCESS]: (draft, action) => {
  //   draft.configurationDataLoading = false;
  //   draft.taskData = action.taskData;
  //   draft.configurationData = action.configurationData;
  //   draft.readOnly = action.readOnly;
  // },
  //
  // [FETCH_CONFIGURATION_DATA_ERROR]: draft => {
  //   draft.configurationDataLoading = false;
  // },
  //
  // [UPDATE_TASK_LOCALLY]: (draft, action) => {
  //   draft.taskData = action.taskData;
  // },
  //
  // [UPDATE_TASK]: (draft, action) => {
  //   draft.saving = true;
  //   draft.taskData = action.taskData;
  // },
  //
  // [UPDATE_TASK_SUCCESS]: draft => {
  //   draft.saving = false;
  // },
  //
  // [UPDATE_CONFIGURATION]: (draft, action) => {
  //   draft.saving = true;
  //   draft.configurationData = action.configurationData;
  // },
  //
  // [UPDATE_CONFIGURATION_SUCCESS]: (draft, action) => {
  //   draft.saving = false;
  //   draft.configurationData = action.configurationData;
  // },
  //
  // [UPDATE_ERRORS]: (draft, action) => {
  //   draft.errors = action.errors;
  // },
  //
  // [DELETE_CAPABILITIES]: (draft, action) => {
  //   draft.saving = true;
  //   draft.capabilities = action.capabilities;
  // },
  //
  // [DELETE_CAPABILITIES_SUCCESS]: draft => {
  //   draft.saving = false;
  // },
  //
  // [FETCH_CAPABILITIES]: draft => {
  //   draft.loading = true;
  // },
  //
  // [FETCH_CAPABILITIES_SUCCESS]: (draft, action) => {
  //   draft.loading = false;
  //   draft.capabilities = action.capabilities;
  // },
  //
  // [UPDATE_CAPABILITIES]: (draft, action) => {
  //   draft.saving = true;
  //   draft.capabilities = action.capabilities;
  // },
  //
  // [UPDATE_CAPABILITIES_SUCCESS]: draft => {
  //   draft.saving = false;
  // },
  //
  // [UPDATE_CAPABILITIES_ERROR]: (draft, action) => {
  //   draft.saving = false;
  //   draft.capabilities = action.capabilities;
  // },
  //
  // [FETCH_PARTS]: draft => {
  //   draft.loading = true;
  // },
  //
  // [FETCH_PARTS_SUCCESS]: (draft, action) => {
  //   draft.loading = false;
  //   draft.partsData = action.partsData;
  //   draft.displayGetPartsError = action.displayGetPartsError;
  // },
  //
  // [FETCH_PARTS_ERROR]: (draft, action) => {
  //   draft.loading = false;
  //   draft.partsData = action.partsData;
  //   draft.displayGetPartsError = action.displayGetPartsError;
  // },
  //
  // [UPDATE_PARTS]: draft => {
  //   draft.refreshPartsLoading = true;
  // },
  //
  // [UPDATE_PARTS_SUCCESS]: (draft, action) => {
  //   draft.refreshPartsLoading = false;
  //   draft.partsData = action.partsData;
  //   draft.displayGetPartsError = action.displayGetPartsError;
  // },
  //
  // [UPDATE_PARTS_ERROR]: (draft, action) => {
  //   draft.refreshPartsLoading = false;
  //   draft.partsData = action.partsData;
  //   draft.displayGetPartsError = action.displayGetPartsError;
  // },
  //
  // [SAVE_DISCOUNT]: draft => {
  //   draft.saving = true;
  // },
  //
  // [SAVE_DISCOUNT_SUCCESS]: (draft, action) => {
  //   draft.saving = false;
  //   draft.partsData = action.partsData;
  // },
});
/*eslint-disable*/
